// extracted by mini-css-extract-plugin
module.exports = {"desktop_only":"(min-width: 1024px)","inputError":"inputError-3FfSc"};